var map = {
	"./icon-label-backinstock": "iI3t",
	"./icon-label-backinstock/": "iI3t",
	"./icon-label-backinstock/index": "iI3t",
	"./icon-label-backinstock/index.js": "iI3t",
	"./icon-label-exclusive": "ZWDx",
	"./icon-label-exclusive/": "ZWDx",
	"./icon-label-exclusive/index": "ZWDx",
	"./icon-label-exclusive/index.js": "ZWDx",
	"./icon-label-justin": "YE/W",
	"./icon-label-justin/": "YE/W",
	"./icon-label-justin/index": "YE/W",
	"./icon-label-justin/index.js": "YE/W",
	"./icon-label-lowstock": "JvIO",
	"./icon-label-lowstock/": "JvIO",
	"./icon-label-lowstock/index": "JvIO",
	"./icon-label-lowstock/index.js": "JvIO",
	"./icon-label-monogrammable": "NVUP",
	"./icon-label-monogrammable/": "NVUP",
	"./icon-label-monogrammable/index": "NVUP",
	"./icon-label-monogrammable/index.js": "NVUP",
	"./icon-label-mostwished": "fRQn",
	"./icon-label-mostwished/": "fRQn",
	"./icon-label-mostwished/index": "fRQn",
	"./icon-label-mostwished/index.js": "fRQn",
	"./icon-label-onsale": "dZ8j",
	"./icon-label-onsale/": "dZ8j",
	"./icon-label-onsale/index": "dZ8j",
	"./icon-label-onsale/index.js": "dZ8j",
	"./icon-label-popular": "SoDW",
	"./icon-label-popular/": "SoDW",
	"./icon-label-popular/index": "SoDW",
	"./icon-label-popular/index.js": "SoDW",
	"./icon-label-sellingfast": "UI7c",
	"./icon-label-sellingfast/": "UI7c",
	"./icon-label-sellingfast/index": "UI7c",
	"./icon-label-sellingfast/index.js": "UI7c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = "vJLy";
module.exports = webpackContext;